(ns nl.mediquest.questionnaire-frontend.db)

(def default-db
  {:i18n/locales [:nl :en :ar :pl :tr] ; determines order
   :i18n/languages {:nl {:description "Nederlands"
                         :icon "/images/netherlands-flag-icon.png"}
                    :en {:description "English"
                         :icon "/images/united-kingdom-flag-icon.png"}
                    :ar {:description "اَلْعَرَبِيَّة"
                         :icon "/images/arab-league-flag-icon.png"}
                    :pl {:description "Polski"
                         :icon "/images/polish-flag-icon.svg"}
                    :tr {:description "Türkçe"
                         :icon "/images/turkish-flag-icon.svg"}}})
